import isEqual from 'lodash.isequal';

const sameElementsArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;

  const remaining = [...arr2];

  return arr1.every((item) => {
    const index = remaining.findIndex((i) => isEqual(i, item));

    if (index === -1) return false;

    remaining.splice(index, 1);

    return true;
  });
};

export default sameElementsArrays;
